import { toast } from 'react-toastify';

function join(title, message) {
  return [title, message].filter(Boolean).join(' - ');
}

export const toastr = {
  success(title, message) {
    toast.success(join(title, message));
  },

  error(title, message) {
    toast.error(join(title, message));
  },

  warning(title, message) {
    toast.warning(join(title, message));
  },

  info(title, message) {
    toast.info(join(title, message));
  }
};